import {
  SET_SOCIAL_ENTITIES
} from './mutationTypes'

export const mutations = {
  [SET_SOCIAL_ENTITIES]: (state, payload) => state.socialEntities = payload
}
